import type { ReactNode } from 'react';
import { cn } from './lib/cn';

interface StatusPillProps {
  children: ReactNode;
  tone?: 'neutral' | 'success' | 'warning' | 'danger';
  className?: string;
}

const toneClasses = {
  neutral: 'bg-[var(--surface-raised)] text-[var(--muted-foreground)]',
  success: 'bg-[var(--success-soft)] text-[var(--success)]',
  warning: 'bg-[var(--warning-soft)] text-[var(--warning)]',
  danger: 'bg-[var(--danger-soft)] text-[var(--danger)]',
};

export function StatusPill({ children, tone = 'neutral', className }: StatusPillProps) {
  return (
    <span className={cn('inline-flex rounded-full px-3 py-1 text-xs font-extrabold', toneClasses[tone], className)}>
      {children}
    </span>
  );
}
